module.exports = "<div id=\"foot\">\n    <h5 style=\"display:inline-flex\"><mat-icon>copyright</mat-icon>Copy Rights Reserved DigitalDragons</h5>\n</div>\n"